import moment, { Moment } from 'moment'
import { payoutDateFormat } from '../../../shared/constants/dateFormats'

export const getDateScales = (startDate: Moment, endDate: Moment) => {
  const dateScale: Moment[] = []
  let currentDate = startDate.clone()

  while (currentDate.isBefore(endDate)) {
    dateScale.push(currentDate)
    currentDate = currentDate.clone().add(1, 'month')
  }

  const payoutDateScale = dateScale?.slice(1)
  const revenueDateScale = dateScale?.slice(0, dateScale.length - 1)

  return { payoutDateScale, revenueDateScale }
}

export const getFormattedDate = (date: string) => moment(date).format(payoutDateFormat)
